import { ColumnType } from 'antd/lib/table'
import { FilterOptions, FilterWithItems, FilterWithKey } from '../types'

/**
 * Creates an Ant Design filter predicate for a record property. Search filters
 * perform a case-insensitive substring match; other filters use strict
 * equality. Records with `null` or `undefined` values never match.
 */
export function filterByKey<T>({
  key,
  type,
}: WithKeyFilter<T>): ColumnType<T>['onFilter'] {
  return (value, record) => {
    const recordValue = record[key] as string | number | boolean
    if (recordValue === undefined || recordValue === null) return false
    if (type === 'search')
      return String(recordValue)
        .toLowerCase()
        .includes(String(value).toLowerCase())
    return recordValue === value
  }
}

type WithKeyFilter<T> = FilterOptions<T> &
  (FilterWithKey<T> | FilterWithItems<T>)
